import Vue from "vue";
import base from "../baseMarketing";

export default Object.assign(
    {
        apiUrl: "/account",

        async list({ type, accountId, page = 0 }) {
            const url = this.url(`/${accountId}/credit/${type}/page/${page}`);
            
            return Vue.http.get(url);
        },

        async add({ type, accountId, amount, expirationDate }) {
            const url = this.url(`/${accountId}/credit/${type}`);
            
            return Vue.http.post(url, {
                amount,
                accountId,
                expirationDate,
            });
        },

        async delete({ type, accountId, creditId }) {
            const url = this.url(`/${accountId}/credit/${type}/${creditId}`);

            return Vue.http.delete(url);
        },

        async total({ type, accountId }) {
            const url = this.url(`/${accountId}/credit/${type}/total`);

            return Vue.http.get(url);
        },
    },
    base
);
